<template>
    <div class="billing-payment-container">
        <div class="billing-payment-container__item">
            <common-page-header :heading="getHeading" size="page-plain-header" contentSpacing="medium"></common-page-header>
            <div class="billing-payment-container__item--info">
                <div>
                    <div class="billing-payment-container__item--payment"></div>
                    <span>{{ $t('pages.billing.billing.billing_list_modal.credit_card') }}</span>
                    **** **** **** {{ defaultCardInfo.last4 }}
                </div>
                <common-content-spacer height="small">
                    <div>
                        <common-button
                            :isSubmittable="false"
                            :label="$t('common.microcopy.add')"
                            type="link"
                            @click="toggleBillingPricingModal"
                        ></common-button>
                    </div>
                    <div>
                        <common-button
                            :isSubmittable="false"
                            :label="'Show'"
                            type="link"
                            @click="toggleCardListModal"
                        ></common-button>
                    </div>
                </common-content-spacer>
            </div>
        </div>
        <div class="billing-payment-container__item">
            <common-page-header
                :heading="$t('pages.billing.billing.billing_form.billing_address')"
                size="page-plain-header"
                contentSpacing="medium"
            ></common-page-header>

            <div class="billing-payment-container__item--info">
                <div>
                    <p>{{ $auth.getPractice().name }}</p>
                    <p>{{ billingAddress.address }}</p>
                    <p>
                        {{ billingAddress.zip }} {{ billingAddress.city }},
                        {{ billingAddress.state }}
                    </p>
                </div>
                <common-button
                    :isSubmittable="false"
                    :label="$t('common.microcopy.edit')"
                    type="link"
                    @click="openEditAddressModal"
                ></common-button>
            </div>
        </div>
        <billing-address-modal
            v-if="isAddressModalOpen"
            :states="states"
            :billingAddress="billingAddress"
            @billing-address-saved="billingAddressSaved"
            @close="isAddressModalOpen = false"
        ></billing-address-modal>
        <billing-pricing-modal
            v-if="billingPricingModalOpen"
            :isAlreadySubscribed="true"
            mode="switchMode"
            @close="toggleBillingPricingModal"
        ></billing-pricing-modal>
        <billing-card-list-modal
            v-if="billingCardListModal"
            @close="billingCardListModal = false"
            @card-saved="cardSaved"
        ></billing-card-list-modal>
    </div>
</template>

<script>
    import StatesAPI from 'api/StatesAPI'
    import BillingAddressModal from './BillingAddressModal'
    import BillingPricingModal from 'components/page-elements/practice/billing/BillingPricingModal'
    import BillingCardListModal from 'components/page-elements/practice/billing/BillingCardListModal'
    import BillingPeriodEnum from '@/enums/BillingPeriodEnum'

    export default {
        components: { BillingAddressModal, BillingPricingModal, BillingCardListModal },

        props: {
            paymentInfo: { type: Object, default: null },
        },

        data() {
            return {
                paymentMethod: false,
                isAddressModalOpen: false,
                states: [],
                billingAddress: {},
                billingPricingModalOpen: false,
                billingCardListModal: false,
                defaultCardInfo: {},
                BillingPeriodEnum: BillingPeriodEnum,
            }
        },

        computed: {
            getHeading() {
                return this.$auth.getPractice().activeBillingPeriod === BillingPeriodEnum.MONTHLY
                    ? this.$t('pages.billing.billing.billing_form.monthly')
                    : this.$t('pages.billing.billing.billing_form.annual')
            },
        },

        methods: {
            paymentMethodChanged(event) {
                this.paymentMethod = event
            },

            openEditAddressModal() {
                this.isAddressModalOpen = true
            },

            getStates() {
                StatesAPI.getList().then((response) => {
                    this.states = response
                })
            },

            billingAddressSaved(request) {
                this.isAddressModalOpen = false
                this.billingAddress = request.billingAddress
            },

            toggleBillingPricingModal() {
                this.billingPricingModalOpen = !this.billingPricingModalOpen

                if (this.billingPricingModalOpen) {
                    document.body.classList.add('no-scroll')
                } else {
                    document.body.classList.remove('no-scroll')
                }
            },

            toggleCardListModal() {
                this.billingCardListModal = !this.billingCardListModal
            },

            cardSaved(payload) {
                this.defaultCardInfo = payload.card
            },
            switchMode() {
                return this.$auth.isPracticePremium() ? 'add-card' : 'subscription'
            },
        },

        watch: {
            paymentInfo() {
                this.defaultCardInfo = this.paymentInfo
            },
        },

        mounted() {
            this.getStates()
            this.billingAddress = this.$auth.getPractice().billingAddress
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/page-elements/billing/_billing-payment-method.scss';
</style>
